// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { klaytnBaobab as _klaytnBaobab } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the klaytnBaobab chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1001
 * Chain Name: Klaytn Baobab Testnet
 * Default Block Explorer: https://baobab.klaytnscope.com
 * Default RPC URL: https://public-en-baobab.klaytn.net
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { klaytnBaobab } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: klaytnBaobab,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const klaytnBaobab = createCommon({
	..._klaytnBaobab,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
